/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  RedoOutlined,
  SearchOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import { Col, Row, Space, Input } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { RoleListReq, DeleteRoleReq } from 'Store/manage-role/types'
import { roleListAPI, deleteRoleAPI } from 'Store/manage-role/api'
import { selectRoleList, selectRoleListEvent, selectRoleActionEvent } from 'Store/manage-role/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { clearEventAction } from 'Store/manage-role/actions'
import { clearEventAction as clearRolePermissionEventAction } from 'Store/manage-role-permission/actions'
import { formatDateTime, getDefaultStatus, getMenuTypeName } from 'helpers/format'
import { StatusTag } from 'Components/utilities'
import { DefaultStatus, menuDefaultStatus, menuRoleMerchantType } from 'helpers/constanst'
import { ConfirmDailog } from 'Components/modal'
import { TableListPage } from 'Components/common/Table'
import { ActionButton, PrimaryButton } from 'Components/button'
import RoleDetail from './RoleDetail'
import EventModal from 'Components/modal/EventModal'
import { Pagination } from 'Components/Pagination'
import { SelectItem } from 'Components/form'
import RolePermissionsDetail from './RolePermissionsDetail'
import { refreshPermissionAPI } from 'Store/manage-role-permission/api'
import { selectRefreshPermissionEvent } from 'Store/manage-role-permission/selector'
import { appConfig } from 'config'

type Props = {} & ReduxProps

const Roles: React.FunctionComponent<Props> = props => {
  const { currentUser, listEvent, list, event, refreshPermissionEvent } = props
  const dispatch = useDispatch()
  const [drawer, setDrawer] = useState(false)
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false)
  const [selectedID, setSelectedID] = useState(0)
  const [showManagePermission, setShowManagePermission] = useState(false)
  const [pageMode, setPageMode] = useState('create' as 'create' | 'edit' | 'deleted')

  const [filter, setFilter] = useState({
    keyword: '',
    merchant_type: '',
    status: '',
    order_by: 'id',
    sort: 'desc',
  })
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })
  const meta = list.meta
  const datas = list.data

  const onGetList = (): void => {
    const req: RoleListReq = {
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      name: filter.keyword,
      merchant_type: filter.merchant_type,
      status: filter.status,
      order_by: filter.order_by || 'id',
      sort: filter.sort || 'desc',
    }
    dispatch(roleListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const onRefreshPermission = (): void => {
    dispatch(refreshPermissionAPI({}, appConfig.fixInternalToken || ''))
  }

  const onDelete = (id: number): void => {
    const req: DeleteRoleReq = {
      id,
    }
    dispatch(deleteRoleAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetList()
    }
  }, [pagination])

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const onSort = (order_by: string, sort: string) => {
    setFilter({
      ...filter,
      sort,
      order_by,
    })
  }

  useEffect(() => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }, [filter?.order_by, filter?.sort])

  const onOpenDrawer = () => {
    setDrawer(true)
  }

  const onCloseDrawer = () => {
    setDrawer(false)
  }

  const onOpenConfirmDelete = () => {
    setConfirmDeleteDialog(true)
  }

  const onCloseConfirmDelete = () => {
    setConfirmDeleteDialog(false)
  }

  const onClickCreate = () => {
    setPageMode('create')
    setSelectedID(0)
    onOpenDrawer()
  }

  const onClickEdit = (id: number) => {
    setPageMode('edit')
    setSelectedID(id)
    onOpenDrawer()
  }

  const onClickDelete = (id: number) => {
    setPageMode('deleted')
    setSelectedID(id)
    onOpenConfirmDelete()
  }

  const onConfirmDelete = () => {
    onDelete(selectedID)
    onCloseConfirmDelete()
  }

  const onSuccess = () => {
    onCloseDrawer()
    onGetList()
  }

  const onManageSuccess = () => {
    onGetList()
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const clearRefreshEvent = (): void => {
    dispatch(clearRolePermissionEventAction())
  }

  const onDeleteSuccess = (): void => {
    clearEvent()
    onGetList()
  }

  const renderStatus = (status: DefaultStatus) => (
    <StatusTag isPass={status === DefaultStatus.ACTIVE} text={getDefaultStatus(status)} />
  )

  const renderActionButton = (text: string, record: any) => (
    <Space size="middle">
      <ActionButton
        text=""
        icon={<SettingOutlined />}
        label="จัดการ permission"
        action="success"
        onClick={() => {
          setShowManagePermission(true)
          setSelectedID(record.id || 0)
        }}
      />
      <ActionButton
        text=""
        icon={<EditOutlined />}
        label="แก้ไข"
        action="edit"
        onClick={() => onClickEdit(record.id)}
      />
      <ActionButton
        text=""
        icon={<DeleteOutlined />}
        label="ลบ"
        action="deleted"
        onClick={() => onClickDelete(record.id)}
      />
    </Space>
  )

  const columns = [
    // {
    //   title: 'ลำดับ',
    //   dataIndex: 'no',
    //   key: 'no',
    //   render: (value: any, record: any, index: number) => {
    //     return index + 1 + (pagination.Page - 1) * pagination.RowPerPage
    //   },
    //   width: '60px',
    // },
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      sorter: true,
      width: '60px',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      //  render: renderCompanyInfo,
      sorter: true,
    },
    // {
    //   title: 'Description',
    //   dataIndex: 'description',
    //   key: 'description',
    //   sorter: true,
    // },
    {
      title: 'Merchant Type',
      key: 'merchant_type',
      dataIndex: 'merchant_type',
      sorter: true,
      render: (val: string) => getMenuTypeName(menuRoleMerchantType, val),
    },
    {
      title: 'สถานะ',
      key: 'status',
      dataIndex: 'status',
      render: renderStatus,
      sorter: true,
    },
    {
      title: 'วันที่สร้าง',
      key: 'created_at',
      dataIndex: 'created_at',
      sorter: true,
      render: (val: string) => formatDateTime(val),
    },
    {
      title: '',
      key: 'action',
      render: renderActionButton,
      width: '150px',
    },
  ]

  const ManageDrawer = (
    <RolePermissionsDetail
      mode={pageMode}
      id={selectedID}
      visible={showManagePermission}
      onCloseDrawer={() => setShowManagePermission(false)}
      onSuccess={onManageSuccess}
    />
  )

  const DetailDrawer = (
    <RoleDetail
      mode={pageMode}
      id={selectedID}
      visible={drawer}
      onCloseDrawer={onCloseDrawer}
      onSuccess={onSuccess}
    />
  )

  const LoadingModal = (
    <EventModal
      event={[event]}
      enable={pageMode === 'deleted'}
      successCalback={onDeleteSuccess}
      errorCalback={clearEvent}
    />
  )

  const RefreshLoadingModal = (
    <EventModal
      event={[refreshPermissionEvent]}
      enable={true}
      successCalback={clearRefreshEvent}
      errorCalback={clearRefreshEvent}
    />
  )

  const ConfirmDeleteModal = (
    <ConfirmDailog
      isShow={confirmDeleteDialog}
      handleOk={onConfirmDelete}
      handleCancel={onCloseConfirmDelete}
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="space-between" align="middle" gutter={[8, 8]}>
        <Col xs={24} md={17}>
          <Row gutter={[8, 8]}>
            <Col xs={24} md={6}>
              <SearchInput
                placeholder="ชื่อ Roles"
                prefix={<SearchOutlined />}
                allowClear
                value={filter.keyword}
                onChange={(evt: any): void => onFilter('keyword', evt.target.value)}
              />
            </Col>
            <Col xs={24} md={6}>
              <SelectItem
                name={'merchant_type'}
                label={''}
                isRequired={true}
                value={filter.merchant_type}
                menu={menuRoleMerchantType}
                placeHolder={'Merchant Type'}
                onChange={(val: any): void => onFilter('merchant_type', val)}
              />
            </Col>
            <Col xs={24} md={6}>
              <SelectItem
                name={'status'}
                label={''}
                isRequired={true}
                value={filter.status}
                menu={menuDefaultStatus}
                placeHolder={'สถานะ'}
                onChange={(val: any): void => onFilter('status', val)}
              />
            </Col>
            <Col>
              <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} />
            </Col>
          </Row>
        </Col>
        <Col>
          <Space size="middle">
            <PrimaryButton text="เพิ่ม Roles" icon={<PlusOutlined />} onClick={onClickCreate} />
            <PrimaryButton
              btnType="Reject"
              text="Refresh เมนู"
              icon={<RedoOutlined />}
              onClick={onRefreshPermission}
            />
          </Space>
        </Col>
      </Row>
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  return (
    <>
      {FilterContent}
      <TableListPage
        columns={columns}
        datas={datas}
        isLoading={listEvent.IsLoading}
        paginationContent={PaginationContent}
        onSort={onSort}
        scrollX={800}
        size="small"
      />
      {LoadingModal}
      {DetailDrawer}
      {ConfirmDeleteModal}
      {ManageDrawer}
      {RefreshLoadingModal}
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    list: selectRoleList(state),
    listEvent: selectRoleListEvent(state),
    event: selectRoleActionEvent(state),
    refreshPermissionEvent: selectRefreshPermissionEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`

export default connect(mapStateToProps)(Roles)
